export default __webpack_public_path__ + "static/media/With_Clarity_Logo.efe4e132.svg";